import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CommentList.css';
import sortBy from 'lodash/sortBy';
import MessageForm from '../../components/MessageForm';
import { MESSAGE_TYPE_COMMENT } from '../../components/MessageForm';
import { userShape, wallCommentShape, wallPostShape } from '../../utils/shapes';
import Comment from './Comment';
import findIndex from 'lodash/findIndex';
import FadeElement from '../FadeElement/index';
import { fromJS } from 'immutable';

class CommentList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      commentsShown: 1,
      commentsToRemove: [],
      message: '',
      submitting: false
    };

    this.loadMore = this.loadMore.bind(this);
    this.showLess = this.showLess.bind(this);
    this.loadMoreAvailable = this.loadMoreAvailable.bind(this);
    this.showLessAvailable = this.showLessAvailable.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.isNewComment = this.isNewComment.bind(this);
    this.isCommentRemoving = this.isCommentRemoving.bind(this);
    this.beginDeleteComment = this.beginDeleteComment.bind(this);
    this.deleteComment = this.deleteComment.bind(this);
  }

  handleChange(event) {
    this.setState({
      message: event.target.value
    });
  }

  handleKeyDown(event) {
    if (event.key === 'Enter' && event.shiftKey === false) {
      this.handleSubmit(event);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.props.addComment(this.props.post.id, this.state.message)) {
      this.setState({ message: '', submitting: true });
    }
  }

  /**
   * TODO: Server integration
   *
   * @returns {boolean}
   */
  loadMoreAvailable() {
    const { post } = this.props;

    return post && post.comments && post.comments.hasAnyNext;
  }

  getCommentCount() {
    const { post } = this.props;

    return (
      post &&
      post.comments &&
      post.comments.comments &&
      post.comments.comments.length
    );
  }

  getTotalCommentCount() {
    return this.props.post.commentCount;
  }

  showMoreAvailable() {
    return this.state.commentsShown < this.getCommentCount();
  }

  loadMore() {
    if (
      this.getCommentCount() === this.getTotalCommentCount() &&
      !this.loadMoreAvailable()
    ) {
      this.setState({ commentsShown: this.state.commentsShown + 5 });
      return;
    }

    let toLoad = Math.min(this.getCommentCount() - this.state.commentsShown, 5);

    if (
      toLoad >= this.getCommentCount() - this.state.commentsShown &&
      toLoad !== 0
    ) {
      this.setState({ commentsShown: this.state.commentsShown + toLoad });
      return;
    }

    if (this.loadMoreAvailable()) {
      this.props.loadMoreComments(this.props.post, length => {
        this.setState({ commentsShown: this.state.commentsShown + length });
      });
      return;
    }
  }

  isNewComment(comment) {
    return (
      findIndex(this.props.commentsToAnimate, item => {
        return item.id === comment.id;
      }) >= 0
    );
  }

  isCommentRemoving(comment) {
    return (
      findIndex(this.state.commentsToRemove, item => {
        return item === comment.id;
      }) >= 0
    );
  }

  componentWillReceiveProps(nextProps) {
    nextProps &&
      nextProps.post &&
      nextProps.post.comments &&
      nextProps.post.comments.comments &&
      nextProps.post.comments.comments.forEach(item => {
        if (
          this.isNewComment(item) &&
          findIndex(this.props.post.comments.comments, oldItem => {
            return oldItem.id === item.id;
          }) === -1
        ) {
          this.setState({
            commentsShown: this.state.commentsShown + 1,
            submitting: false
          });
        }
      });
  }

  showLessAvailable() {
    if (this.getCommentCount() !== 0) {
      return this.state.commentsShown > 1;
    }
    return false;
  }

  showLess() {
    this.setState({ commentsShown: 1 });
  }

  beginDeleteComment(postId, comment) {
    this.setState({
      commentsToRemove: fromJS(this.state.commentsToRemove)
        .push(comment.id)
        .toJS()
    });
  }

  deleteComment(postId, comment) {
    this.props.onDeleteComment(postId, comment);
  }

  render() {
    const { post, commentInputShown } = this.props;
    const { commentsShown, message } = this.state;

    const sortedComments =
      post && post.comments && post.comments.comments
        ? sortBy(post.comments.comments, { prop: 'created' })
        : [];

    return (
      <div className="chat-comment-container">
        <div>
          {commentInputShown === post.id || this.state.submitting ? (
            <div className="feed-comment-container reply-comment">
              <MessageForm
                onSubmit={this.handleSubmit}
                onChange={this.handleChange}
                onKeyDown={this.handleKeyDown}
                message={message}
                placeholder={MESSAGE_TYPE_COMMENT}
                disabled={this.state.submitting}
                autoFocus
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <ul className="chat-comment-list">
          {sortedComments.map((comment, idx) => {
            return idx < commentsShown ? (
              <FadeElement
                className="comment-background"
                key={comment.id}
                onTransitionComplete={() => {
                  this.props.onCommentAnimationComplete(comment);
                }}
                onRemoveComplete={() => {
                  this.deleteComment(post.id, comment);
                }}
                in={!this.isNewComment(comment)}
                removing={this.isCommentRemoving(comment)}
              >
                <Comment
                  comment={comment}
                  post={post}
                  onDeleteComment={this.beginDeleteComment}
                  user={this.props.user}
                  onLikeComment={this.props.onLikeComment}
                  onUnlikeComment={this.props.onUnlikeComment}
                />
              </FadeElement>
            ) : null;
          })}
        </ul>
        <div
          className={`load-more
          ${this.loadMoreAvailable() ||
          this.showLessAvailable() ||
          this.showMoreAvailable()
            ? 'comments-exist'
            : ''}`}
        >
          {this.loadMoreAvailable() || this.showMoreAvailable() ? (
            <a
              className={this.showLessAvailable() ? 'left-align' : ''}
              onClick={this.loadMore}
            >
              More Comments…
            </a>
          ) : null}
          {this.showLessAvailable() ? (
            <a
              className={
                this.loadMoreAvailable() || this.showMoreAvailable()
                  ? 'right-align'
                  : ''
              }
              onClick={this.showLess}
            >
              Less Comments…<i className="fa fa-arrow-up" aria-hidden="true" />
            </a>
          ) : null}
        </div>
      </div>
    );
  }
}

CommentList.propTypes = {
  post: wallPostShape,
  comments: PropTypes.arrayOf(wallCommentShape),
  commentInputShown: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  user: userShape,
  onDeleteComment: PropTypes.func,
  addComment: PropTypes.func,
  commentsToAnimate: PropTypes.array,
  onCommentAnimationComplete: PropTypes.func,
  onLikeComment: PropTypes.func,
  onUnlikeComment: PropTypes.func
};

export default CommentList;



// WEBPACK FOOTER //
// ./src/components/CommentList/index.js